exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menuIcon__menuIcon___1-JHO {\n  display: inline-flex;\n  align-items: center;\n  cursor: pointer;\n  color: #000;\n  transition: color 300ms; }\n  .menuIcon__menuIcon___1-JHO svg {\n    width: 19px;\n    height: 14px; }\n  .menuIcon__menuIcon___1-JHO:hover {\n    color: #F94144; }\n", ""]);

// exports
exports.locals = {
	"menuIcon": "menuIcon__menuIcon___1-JHO"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/Header/MobileHeader/MenuIcon/menuIcon.scss
// module id = 3974
// module chunks = 6